
<template>
  <div>
    <div class="right-side-content">
      <div class="d-flex flex-column align-items-center py-3 border-bottom">
        <img
          class="z2-avatar-large mb-1"
          :src="conversation?.avatar || '/assets/images/no-avatar.png'" />
        <div class="d-flex align-items-center px-12">
          <span
            class="font-16 fw-500 me-1 trim-text-1-line"
            style="max-width: 250px">
            {{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : conversation.toName }}
          </span>
          <div @click="showPopOverSwName = true">
            <IconV2
              class="pointer"
              name="v2-edit" />
          </div>
        </div>
        <div class="flex-container-line mt-3">
          <div
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px"
            @click="muteConversation">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2 name="v2-notification_important" />
            </div>
            <span class="mt-2">{{ conversation.pushNotify ? "Tắt thông báo" : "Bật thông báo" }}</span>
          </div>
          <div
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px"
            @click="pinConversation">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2 name="v2-star1" />
            </div>
            <span
              class="mt-2"
              style="height: 39px">
              {{ conversation.isPin ? "Bỏ ghim" : "Ghim hội thoại" }}
            </span>
          </div>
          <div
            v-if="!conversation.group && !conversation.page"
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px"
            @click="addGroup">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2 name="v2-group-add" />
            </div>
            <span class="mt-2">Tạo nhóm trò chuyện</span>
          </div>
          <div
            v-if="conversation.group && !isRemove"
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px"
            @click="addMemberGroup">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2 name="v2-group-add" />
            </div>
            <span class="mt-2">Thêm thành viên</span>
          </div>
          <div
            v-if="conversation.group && !isRemove"
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px"
            @click="viewMemberList = true">
            <el-badge
              v-if="pendingMems?.length"
              :value="pendingMems?.length || 0">
              <div class="z2-btn-status-off z2-btn-circle-large">
                <IconV2 name="v2-group" />
              </div>
            </el-badge>
            <div
              v-else
              class="z2-btn-status-off z2-btn-circle-large">
              <IconV2 name="v2-group" />
            </div>

            <span class="mt-2">Danh sách thành viên</span>
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-column border-bottom"
        style="padding: 12px">
        <div class="flex-container-line">
          <span class="font-14 fw-500">Ảnh / Video</span>
          <i
            class="pointer"
            :class="isExpandMedia ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
            @click="isExpandMedia = !isExpandMedia"></i>
        </div>
        <div v-if="isExpandMedia">
          <div class="mt-1 media-container">
            <div
              v-for="(image, index) in messageMedia"
              :key="index"
              class="z2-img-container pointer"
              @click="openGallery(index)">
              <ImageRetry
                :src="image.thumb"
                :retryMax="4" />
              <img
                v-if="image.msgType === 'chat.video.msg'"
                class="icon-play-media"
                src="/assets/icon/icon-play-media.png" />
              <div
                class="btn-forward"
                @click.stop.prevent="forwardMessage(image)">
                <IconV2
                  name="v2-share"
                  color="#3484F0" />
              </div>
              <div
                class="btn-more"
                @click.stop.prevent="(e) => $emit('showMenu', e, image.raw)">
                <IconV2
                  name="el-icon-more"
                  color="#3484F0" />
              </div>
            </div>
          </div>
          <el-button
            v-if="messageMedia.length > 5"
            class="z2-btn-info font-14 fw-500 w-100"
            type="info"
            size="medium"
            @click="onViewMessageStorage('media')">
            Xem tất cả
          </el-button>
          <div
            v-if="!messageMedia.length"
            class="text-center text-grey600 px-5">
            Chưa có Ảnh / Video được chia sẻ trong hội thoại này
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-column border-bottom"
        style="padding: 12px">
        <div class="flex-container-line">
          <span class="font-14 fw-500">Tài liệu</span>
          <i
            class="pointer"
            :class="isExpandDocument ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
            @click="isExpandDocument = !isExpandDocument"></i>
        </div>
        <div v-if="isExpandDocument">
          <div
            v-for="(file, index) in messageFile"
            :key="index"
            class="z2-img-container">
            <ChatFileV3
              v-if="file.msgType == 'share.file'"
              :preventDownload="false"
              :file="file"
              :account-id="conversation.accountId"
              :message-id="file.id"
              :message-ts="file.ts" />
            <div
              class="btn-more pointer"
              @click.stop.prevent="(e) => $emit('showMenu', e, file)">
              <IconV2
                name="el-icon-more"
                color="#3484F0" />
            </div>
          </div>
          <el-button
            v-if="messageFile.length > 2"
            class="z2-btn-info font-14 fw-500 w-100"
            type="info"
            size="medium"
            @click="onViewMessageStorage('file')">
            Xem tất cả
          </el-button>
          <div
            v-if="!messageFile.length"
            class="text-center text-grey600 px-5">
            Chưa có Tài liệu được chia sẻ trong hội thoại này
          </div>
        </div>
      </div>

      <div
        class="d-flex flex-column border-bottom"
        style="padding: 12px">
        <div class="flex-container-line">
          <span class="font-14 fw-500">Liên kết</span>
          <i
            class="pointer"
            :class="isExpandLink ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
            @click="isExpandLink = !isExpandLink"></i>
        </div>
        <div v-if="isExpandLink">
          <div class="my-2">
            <div
              v-for="(link, index) in messageLink"
              :key="index"
              class="d-flex align-items-center z2-img-container my-2 pointer"
              @click="newTab(JSON.parse(link.content).href)">
              <img
                :src="JSON.parse(link.content).thumb || '/assets/icon/link.png'"
                style="width: 32px; height: 32px; border-radius: 4px" />
              <div class="d-flex flex-column ms-2">
                <span
                  class="font-14 fw-500 trim-text-1-line"
                  style="max-width: 230px">
                  {{ JSON.parse(link.content).description }}
                </span>
                <span class="fw-300">{{ JSON.parse(JSON.parse(link.content).params).src }} · {{ timestampToDatetime(link.ts) }}</span>
              </div>
              <div
                class="btn-forward"
                @click.stop.prevent="copyLink(JSON.parse(link.content).href)">
                <IconV2
                  name="v2-link"
                  color="#3484F0" />
              </div>
              <div
                class="btn-more pointer"
                @click.stop.prevent="(e) => $emit('showMenu', e, link)">
                <IconV2
                  name="el-icon-more"
                  color="#3484F0" />
              </div>
            </div>
          </div>
          <el-button
            v-if="messageLink.length > 2"
            class="z2-btn-info font-14 fw-500 w-100"
            type="info"
            size="medium"
            @click="onViewMessageStorage('link')">
            Xem tất cả
          </el-button>
          <div
            v-if="!messageLink.length"
            class="text-center text-grey600 px-5">
            Chưa có Liên kết được chia sẻ trong hội thoại này
          </div>
        </div>
      </div>

      <div class="flex-1"></div>

      <div
        class="d-flex flex-column border-bottom border-top"
        style="padding: 12px">
        <div class="flex-container-line">
          <span class="font-14 fw-500">Thao tác khác</span>
        </div>
        <div class="d-flex align-items-center justify-content-around mt-3">
          <div
            v-if="conversation.group && !isRemove"
            @click="leaveGroup"
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2
                name="v2-exit"
                size="18px" />
            </div>
            <span class="mt-2">Rời nhóm</span>
          </div>
          <div
            @click="hideConversation"
            class="d-flex flex-column align-items-center text-center"
            :style="!conversation.group && { width: '72px' }">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <img src="/assets/icon/icon-unread-v2.svg" />
            </div>
            <span class="mt-2">Ẩn trò chuyện</span>
          </div>
          <!-- <div
            v-if="conversation.group"
            @click="hideConversation"
            class="d-flex flex-column align-items-center text-center">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <IconV2
                name="v2-close"
                size="18px"
                color="#CF4343" />
            </div>
            <span class="mt-2 text-red500">Giải tán nhóm</span>
          </div> -->

          <div
            v-if="!conversation.group && !conversation.page"
            @click="handleActionBlock(profile.isBlocked ? 'unblock' : 'block')"
            class="d-flex flex-column align-items-center text-center"
            style="width: 72px">
            <div class="z2-btn-status-off z2-btn-circle-large">
              <img src="/assets/icon/icon_red_block.svg" />
            </div>
            <span class="mt-2">{{ profile.isBlocked ? "Bỏ chặn" : "Chặn người dùng" }}</span>
          </div>
        </div>
      </div>
    </div>

    <MessageStorage
      v-if="messageType"
      :conversation="conversation"
      :messageType="messageType"
      @close="messageType = ''" />

    <div
      v-if="viewMemberList && conversation.group"
      class="z2-members-info">
      <div
        class="d-flex align-items-center justify-content-between px-2 border-bottom"
        style="height: 56px">
        <div
          class="pointer"
          @click="viewMemberList = false">
          <IconV2
            name="v2-arrow2_left"
            size="24px" />
        </div>
        <span class="font-16 fw-500">Thành viên ({{ members.length }})</span>
        <div
          class="p-1 rounded-2 pointer"
          style="background-color: #e1edfd"
          @click="addMemberGroup">
          <IconV2
            name="v2-group-add"
            color="#3484F0" />
        </div>
      </div>
      <div
        class="px-12 py-2 border-bottom"
        style="background-color: #fafafa">
        <el-input
          v-model="searchMember"
          placeholder="Tìm kiếm thành viên trong nhóm"
          size="small">
          <IconV2
            slot="prefix"
            class="my-2 ms-1"
            name="v2-search" />
        </el-input>
      </div>
      <div style="height: calc(100vh - 106px); overflow-y: auto">
        <div
          v-if="viewPendingMems.length"
          class="mt-1 font-14">
          <span class="fw-semibold text-blue600 mx-2">Yêu cầu tham gia ({{ viewPendingMems.length }})</span>
          <div style="max-height: 30vh; overflow-y: auto">
            <div
              v-for="item in viewPendingMems"
              :key="item.id">
              <div
                class="mt-2 d-flex align-items-center"
                style="height: 48px">
                <div class="d-flex align-items-center flex-1 px-12">
                  <div class="d-flex align-items-center flex-1">
                    <img
                      :src="item.avatar"
                      class="rounded-circle me-2 pointer"
                      width="40"
                      @click="item.accountId !== item.uid && showInfo({ ...item, id: item.uid, accountId: conversation.accountId })" />
                    <div class="d-flex flex-column">
                      <span class="font-14 fw-500">{{ item.dpn }}</span>
                      <span
                        class="font-14 trim-text-1-line"
                        style="max-width: 220px">
                        {{ item.user_submit }}
                        <div>
                          <span
                            class="highlight-text me-1 text-red500 fw-semibold"
                            @click="onAcceptRequestJoinGroup(0, item.uid)">
                            Từ chối
                          </span>
                          <span
                            class="highlight-text fw-semibold text-blue600"
                            @click="onAcceptRequestJoinGroup(1, item.uid)">
                            Duyệt
                          </span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-divider class="my-2"></el-divider>
        </div>

        <div
          v-for="item in viewMembers"
          :key="item.id"
          class="mt-2 d-flex align-items-center"
          style="height: 48px">
          <div class="d-flex align-items-center flex-1 px-12">
            <div class="d-flex align-items-center flex-1">
              <img
                :src="item.avatar"
                class="rounded-circle me-2 pointer"
                width="40"
                @click="item.accountId !== item.id && showInfo(item)" />
              <span class="font-14 fw-500">{{ item.name }}</span>
            </div>

            <el-popover
              popper-class="p-0"
              placement="left"
              trigger="click"
              @hide="resetData">
              <div
                v-if="item.accountId !== item.id"
                class="context-menu-item pointer px-2"
                style="height: 32px"
                @click="showInfo(item)">
                <IconV2 name="v2-info2" />
                <span class="ms-1 font-13 text-grey600">Xem thông tin</span>
              </div>
              <div
                v-if="item.accountId !== item.id && !profileMember.isFr && !loadingProfile && requestFriend.is_requested === 0"
                class="context-menu-item pointer px-2"
                style="height: 32px"
                @click="addFriend(item)">
                <IconV2 name="v2-user-add" />
                <span class="ms-1 font-13 text-grey600">Thêm bạn</span>
              </div>
              <div
                v-if="item.accountId !== item.id && !profileMember.isFr && !loadingProfile && requestFriend.is_requested === 1"
                class="context-menu-item px-2"
                style="height: 32px">
                <img
                  src="/assets/icon/user-send.svg"
                  width="16" />
                <span class="ms-1 font-13 text-grey600">Đã gửi lời mời kết bạn</span>
              </div>
              <el-divider class="m-0 p-0" />
              <div
                v-if="item.accountId === item.id"
                class="context-menu-item pointer px-2"
                style="height: 32px"
                @click="leaveGroup">
                <IconV2 name="v2-exit" />
                <span class="ms-1 font-13 text-grey600">Rời khỏi nhóm</span>
              </div>
              <div
                v-if="item.accountId !== item.id && isCanDeleteGroup"
                class="context-menu-item pointer px-2"
                style="height: 32px"
                @click="deleteMember(item)">
                <IconV2
                  name="v2-close"
                  color="#CF4343" />
                <span class="ms-1 font-13 text-grey600">Xóa khỏi nhóm</span>
              </div>
              <div
                @click="onClickMenuMember(item)"
                class="p-1 pointer"
                slot="reference">
                <IconV2 name="icon-more-vertical" />
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="'Đặt biệt danh cho ' + conversation.toName"
      width="400px"
      v-if="showPopOverSwName"
      :visible.sync="showPopOverSwName"
      destroy-on-close>
      <div>
        <el-input
          placeholder="Nhập biệt danh"
          type="textarea"
          :rows="3"
          v-model="conversation.swName"
          @keydown.enter.exact.native="saveSwName"
          resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="saveSwName">
            Lưu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- <el-dialog
      title="Tạo nhóm"
      :visible.sync="dialogCreateGroup"
      :close-on-click-modal="false"
      width="800px"
      top="2vh"
      destroy-on-close
      append-to-body
      @opened="$refs.createGrMsg.setAccountId(conversation.accountId)">
      <create-group
        ref="createGrMsg"
        :account-id="conversation.accountId"
        :userId="profile ? profile.userId : null"
        @close="dialogCreateGroup = false" />
    </el-dialog> -->

    <DialogCreateGroup
      v-if="dialogCreateGroup"
      :dialogCreateGroup="dialogCreateGroup"
      :conversation="conversation"
      :account-id="conversation.accountId"
      :userId="profile ? profile.userId : null"
      @close="dialogCreateGroup = false" />

    <DialogAddMember
      v-if="dialogGroup"
      :dialogAddMember="dialogGroup"
      :conversation="conversation"
      :members="members"
      @close="dialogGroup = false"
      @addMembers="$emit('getGroupInfo', conversation)" />

    <!-- <el-dialog
      v-if="dialogGroup"
      width="800px"
      top="40px"
      :visible.sync="dialogGroup"
      title="Thêm thành viên"
      append-to-body
      destroy-on-close>
      <AddMember
        :conversation="conversation"
        :members="members"
        @close="dialogGroup = false"
        @addMembers="$emit('getGroupInfo', conversation)" />
    </el-dialog> -->

    <el-dialog
      v-if="showProfile && profileMember.userId"
      width="300px"
      :visible.sync="showProfile"
      title="Thông tin tài khoản"
      class="dialogProfileV2">
      <div
        slot="title"
        class="font-16 fw-500">
        Thông tin tài khoản
      </div>
      <ProfileInfoPopupV2
        :data="profileMember"
        :conversation="conversationMember"
        @closeProfile="showProfile = false" />
    </el-dialog>

    <DialogRequestFriendV2
      :data="profileMember"
      :visibleRequestFriend="visibleRequestFriend"
      :requestStatus="requestFriend"
      @close="visibleRequestFriend = false" />

    <LightBox
      ref="lightbox"
      :media="messageMedia"
      :show-caption="true"
      :show-light-box="false" />
  </div>
</template>

<script>
/* eslint-disable */
import CreateGroup from "./contact/CreateGroup";
import AddMember from "@/components/AddMember";
import DialogRequestFriendV2 from "./contact/DialogRequestFriendV2.vue";
import LightBox from "./common/LightBox/LightBox";
import ChatFileV3 from "./message/ChatFileV3";
import MessageStorage from "./MessageStorage.vue";
import ProfileInfoPopupV2 from "./ProfileInfoPopupV2.vue";
import ImageRetry from "./common/ImageRetry.vue";
import DialogCreateGroup from "./message/DialogCreateGroup.vue";
import DialogAddMember from "./message/DialogAddMember.vue";
import moment from "moment";

export default {
  props: ["conversation", "messageMedia", "messageFile", "messageLink", "profile", "members", "pendingMems", "isCanDeleteGroup", "isRemove"],
  components: {
    CreateGroup,
    AddMember,
    DialogRequestFriendV2,
    LightBox,
    ChatFileV3,
    MessageStorage,
    ProfileInfoPopupV2,
    ImageRetry,
    DialogCreateGroup,
    DialogAddMember,
  },
  data() {
    return {
      isExpandMedia: true,
      isExpandDocument: true,
      isExpandLink: true,

      showPopOverSwName: false,
      dialogCreateGroup: false,
      dialogGroup: false,

      searchMember: "",
      viewMemberList: false,
      loadingProfile: false,
      showProfile: false,
      profileMember: {},
      conversationMember: {},
      requestFriend: {},
      visibleRequestFriend: false,

      messageType: "",
    };
  },
  computed: {
    viewMembers() {
      if (!this.searchMember) return this.members;
      return this.members.filter((p) => p.name.toLowerCase().includes(this.searchMember.toLowerCase()));
    },
    viewPendingMems() {
      if (!this.searchMember) return this.pendingMems || [];
      return this.pendingMems.filter((p) => p.dpn.toLowerCase().includes(this.searchMember.toLowerCase()));
    },
  },
  methods: {
    timestampToDatetime(ts) {
      return moment(Number(ts)).format("DD/MM/YYYY");
    },
    saveSwName() {
      this.$http.get("/api/conversation/setSwName", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          swName: this.conversation.swName,
        },
      });
      this.showPopOverSwName = false;
    },
    async muteConversation() {
      await this.$http.get("/api/conversation/pushNotify", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          pushNotify: !this.conversation.pushNotify,
        },
      });
      this.conversation.pushNotify = !this.conversation.pushNotify;
    },
    pinConversation() {
      // this.conversation.isPin = !this.conversation.isPin;
      let request = [];
      if (this.conversation.isPin) {
        let filterIdx = this.app.pinConversations.findIndex((m) => m.id == this.conversation.id);
        if (filterIdx > -1) {
          this.app.pinConversations.splice(filterIdx, 1);
        }
      } else {
        request.push({
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
        });
      }
      this.app.pinConversations.forEach((p) => {
        request.push({
          accountId: p.accountId,
          conversationId: p.id,
        });
      });
      this.$http.post("/api/conversation/pin/save", { items: request }).then(() => {
        this.fetchPinConversation();
        this.$bus.$emit("updatePinConversation", !this.conversation.isPin);
      });
    },
    addGroup() {
      this.dialogCreateGroup = true;
    },
    addMemberGroup() {
      this.dialogGroup = true;
    },
    leaveGroup() {
      this.$http
        .get("/api/conversation/leaveGroup", {
          params: {
            groupId: this.conversation.toId,
            accountId: this.conversation.accountId,
          },
        })
        .then((resp) => {
          if (resp.data?.error_message === "Successful.") {
            // this.alert("success", "Rời nhóm thành công");
            this.$bus.$emit("leaveGroup", this.conversation);
            this.$emit("getGroupInfo", this.conversation);
          } else this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
        });
    },
    deleteMember(member) {
      this.$confirm("Bạn chắc chắn muốn xóa?", "Cảnh báo", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("/api/conversation/removeGroupMember", {
              params: {
                accountId: member.accountId,
                memberId: member.id,
                groupId: this.conversation.toId,
                name: member.name,
              },
            })
            .then(() => {
              this.alert("success", "Đã xóa " + member.name + " ra khỏi nhóm!");
              this.$emit("getGroupInfo", this.conversation);
            });
        })
        .catch(() => {});
    },

    async onClickMenuMember(member) {
      this.resetData();
      const resp = await this.$http.get("/api/message/getProfileInfo", {
        params: {
          accountId: member.accountId,
          profileId: member.id,
        },
      });
      this.profileMember = resp.data.data.changed_profiles[member.id];
      this.profileMember.accountId = member.accountId;
      if (!this.profileMember?.isFr) {
        await this.friendRequestStatus(member);
      } else {
        this.loadingProfile = false;
      }
    },
    async friendRequestStatus(member) {
      let request = {
        accountId: member.accountId,
        friendId: member.id,
      };
      return await this.$http.post("/api/conversation/friendRequestStatus", request).then((resp) => {
        if (resp.data.error_code === 0) {
          this.requestFriend = resp.data.data;
        }
        this.loadingProfile = false;
        return resp.data.data;
      });
    },
    async showInfo(member) {
      this.resetData();
      const resp = await this.$http.get("/api/message/getProfileInfo", {
        params: {
          accountId: member.accountId,
          profileId: member.id,
        },
      });
      this.profileMember = resp.data.data.changed_profiles[member.id];
      this.profileMember.accountId = member.accountId;

      const respConv = await this.$http.post("/api/conversation/all", {
        accountId: this.conversation.accountId,
        searchKey: "",
        selectedTags: [],
        pageSize: 1,
        page: 1,
        type: "personal",
        toId: member.id,
      });
      this.conversationMember = respConv.data ? respConv.data.content[0] : {};
      this.showProfile = true;
    },
    async addFriend() {
      this.visibleRequestFriend = true;
    },
    resetData() {
      this.visibleRequestFriend = false;
      this.loadingProfile = false;
      this.profileMember = {};
      this.conversationMember = {};
      this.requestFriend = {};
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
    forwardMessage(message) {
      this.$bus.$emit("forwardMessage", message.raw);
    },
    copyLink(link) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Sao chép thành công!");
    },
    hideConversation() {
      this.$confirm("Bạn có chắc chắn muốn ẩn liên hệ này trong phần Danh sách tin nhắn không?", "Xác nhận ẩn liên hệ", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      }).then(async () => {
        await this.$http.get("/api/conversation/hidden", {
          params: {
            accountId: this.conversation.accountId,
            conversationId: this.conversation.id,
            hidden: true,
          },
        });
      });
    },
    handleActionBlock(action) {
      let request = {
        accountId: this.conversation.accountId,
        friendId: this.conversation.toId,
        action: action,
        conversationId: this.conversation.id,
      };
      this.$http.post("/api/message/block", request).then((resp) => {
        if (resp?.data?.error_message !== "Successful.") return this.alert("error", "Có lỗi xảy ra vui lòng thử lại");
        if (action === "block") {
          this.profile.isBlocked = 1;
          this.alert("success", "Chặn thành công, người dùng này sẽ không thể gửi tin nhắn tới bạn");
        } else {
          this.profile.isBlocked = 0;
          this.alert("success", "Bỏ chặn thành công");
        }
      });
    },

    onViewMessageStorage(messageType) {
      this.messageType = messageType;
    },

    onAcceptRequestJoinGroup(value, uid) {
      this.$http
        .post("/api/message/reviewJoinGroup", {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          isApprove: value,
          members: [uid],
        })
        .then(() => {
          this.alert("success", `${value ? "Duyệt" : "Từ chối"} thành công!`);
          this.$bus.$emit("AcceptMemsJoinGroup", this.conversation);
        });
    },
    hanleReplaceLink(data) {
      // this.messageMedia = this.messageMedia.map(day => {
      //     if (day.raw.id.msgId == data.msgId) {
      //       day.thumb = data.link;
      //     }
      //     return day;
      // })
      const FIFTEEN_DAYS_MS = 15 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      this.messageMedia.forEach(day => {
        if (day.raw.id.msgId == data.msgId && (now - d.raw.ts) >= FIFTEEN_DAYS_MS) {
            day.thumb = data.link;
          }
      })  
    },
  },
  created() {
    this.$bus.$on("selectConversationV2", () => {
      this.messageType = "";
    });
  },
  beforeDestroy() {
    this.$bus.$off("leaveGroup");
  },
  mounted() {
    this.$bus.$on("ReplaceLinkEvent", (data) => {
      this.hanleReplaceLink(data);
    });
  },
};
</script>

<style lang="scss" scoped>
.right-side-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 57px) !important;
  min-height: calc(100vh - 57px) !important;
  overflow-y: auto;
}

.right-side-content::-webkit-scrollbar {
  display: none;
}

.right-side-content {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

.z2-img-container {
  position: relative;
  margin-bottom: 4px;
}
.z2-img-container:hover {
  .btn-forward {
    display: block;
  }
  .btn-more {
    display: block;
  }
}
.btn-forward,
.btn-more {
  display: none;
  position: absolute;
  background-color: #f4f5f9;
  top: 4px;
  right: 6px;
  padding: 1px;
  border-radius: 4px;
}

.btn-more {
  right: 6px;
}

.btn-forward {
  right: 26px;
}

.icon-play-media {
  position: absolute;
  top: 32px;
  left: 32px;
}
.media-container {
  margin: 0.5rem 0 0 0rem;
  display: grid;
  max-width: 100%;

  grid-template-columns: repeat(auto-fill, minmax(88px, 1fr));
}

.z2-members-info {
  position: absolute;
  width: 290px;
  height: 100vh;
  top: 0;
  z-index: 99;
  background-color: white;
}

.context-menu {
  position: fixed;
  background-color: #fff;
  border: thin solid #f5f6f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  cursor: pointer;
}

.context-menu div {
  padding: 0.25rem 0.5rem 0.25rem 0.5rem;
}

.context-menu-item {
  display: flex;
  align-items: center;
}

.context-menu-item:hover {
  color: var(--el-color-primary);
  background-color: #e8f0fb;
}

.highlight-text:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>